import React from 'react';
import cn from 'classnames';

import Form from '../../../components/form/Form';
import InputField from '../../../components/form/InputField';
import Button from '../../../components/common/ui/Button';
import ExitIcon from '../../../assets/icons/common/ExitIcon';
import FormError from '../../../components/form/FormError';
import { MOUSEFLOW_MASKED } from '../../../constants/mouseflowClasses';

import styles from './styles.module.scss';

const ProfileForm = ({ formik, customer, handleLogout }) => {
  const showSave =
    formik.values.first_name !== customer?.first_name ||
    formik.values.last_name !== customer?.last_name ||
    formik.values.phone !== (customer?.phone || '');

  return (
    <Form className={styles.form} formik={formik}>
      <p className={styles.title}>Personal Info</p>
      <div className={styles.row}>
        <label>First Name</label>
        <InputField
          className={styles.inputWrapper}
          name="first_name"
          formik={formik}
          placeholder="First name"
        />
      </div>
      <div className={styles.row}>
        <label>Last Name</label>
        <InputField
          className={styles.inputWrapper}
          name="last_name"
          formik={formik}
          placeholder="Last name"
        />
      </div>
      <div className={styles.row}>
        <label>Phone</label>
        <InputField
          className={cn(MOUSEFLOW_MASKED, styles.inputWrapper)}
          name="phone"
          formik={formik}
          placeholder="+19991234567"
        />
      </div>
      <div className={cn(styles.row, styles.emailRow)}>
        <label>Email</label>
        <div className={styles.immutableValue}>{customer?.email}</div>
      </div>
      <FormError error={formik.status} />
      <div className={styles.buttons}>
        <Button
          className={styles.logout}
          colorType="grey"
          onClick={handleLogout}
        >
          <ExitIcon />
          Logout
        </Button>
        {showSave && (
          <Button type="submit" className={styles.save}>
            Save
          </Button>
        )}
      </div>
    </Form>
  );
};

export default ProfileForm;
